var map = {
	"./baby_corn.png": 2115,
	"./cabbage.png": 5084,
	"./chicken.png": 8928,
	"./corn.png": 7239,
	"./cucumber.png": 554,
	"./exam.png": 8268,
	"./lover.png": 9427,
	"./mushroom.png": 6682,
	"./party.png": 4996,
	"./pig_blood_cake.png": 976,
	"./sausage.png": 4567,
	"./seasick.png": 8017,
	"./silk-thread_roll.png": 2161,
	"./single.png": 7934,
	"./sweet_potato.png": 4483,
	"./tempura.png": 4301,
	"./tempura2.png": 3659,
	"./tofu.png": 7800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1791;